<template>
  <div class="Wdgt-Content-Ttl" :style="wrapperAlphaStyle">
    <template v-if="get_isLabel">
      <AvatarImage class="Wdgt-Content-Ttl__icon" :src="pon_chat" :size="avatarSize" :radius="avatarRadius" v-if="get_isPon"/>
      <AvatarImage class="Wdgt-Content-Ttl__icon" :src="get_newsLabel" :size="avatarSize" :radius="avatarRadius" v-else-if="get_isNews"/>
      <AvatarImage class="Wdgt-Content-Ttl__icon" :src="get_cover" :size="avatarSize" :radius="avatarRadius" v-else-if="get_isCover"/>
      <AvatarImage class="Wdgt-Content-Ttl__icon" :src="get_userAvatar" :size="avatarSize" :radius="avatarRadius" v-else/>
    </template>
    <h1 class="Wdgt-Content-Ttl__txt" :class="[get_marginTtlClass, get_alphaAvatarClass]" v-html="get_ttl"></h1>
  </div>
</template>

<script setup>
import {defineProps, computed} from 'vue';
import {Props} from './scripts/props.js';
import {POST_TYPES} from '@shared/constants/posts/postTypes.js';
//-----------------------------------
import AvatarImage from '@ui/Images/AvatarImage/AvatarImage.vue';
//-----------------------------------
const props = defineProps(Props());
//-----------------------------------
const POST = props.post;
//-----------------------------------
const pon_chat = '/media/images/pon_chat.webp';
//-----------------------------------
//Пост относится к новостям
const get_isNews = computed(() => POST.model_name.toLowerCase() === POST_TYPES.NEWS);
//Это Мнение?
const get_isOpinion = computed(() => POST.model_name.toLowerCase() === POST_TYPES.OPINION);
//Пост является подкастом?
const get_isPodcast = computed(() => POST.section_name.toLowerCase() === 'podcast');
//Отображать ли иконку
const get_isLabel = computed(() => !get_isPodcast.value);
//Аватар является ковером для поста
const get_isCover = computed(() => POST.images_list.length > 0 && !get_isOpinion.value);
//Получить cover для поста
const get_cover = computed(() => POST.images_list[0]);
//Получим аватарку пользователя для cover, для мнения без картинок
const get_userAvatar = computed(() => POST.author.avatar);
//Получить иконку изображения
const get_newsLabel = computed(() => POST.news_atributes.label);
//Пост отновистся к каналу 'Выжимка PON'
const get_isPon = computed(() => POST.channels?.some(channel => channel.slug === 'выжимка-pon'));
//Получить заголовок
const get_ttl = computed(() => POST.title);
//Получить тип поста
const get_type = computed(() => props.type);
//Делать красную строку для заголовка или нет (нужно, чтобы поместить иконку поста)
const get_marginTtlClass = computed(() => get_isPodcast.value ? 'Wdgt-Content-Ttl__txt--no-indent' : '')
//Корректировка текста относительно аватарки поста альфы
const get_alphaAvatarClass = computed(() => get_type.value === 'alpha' && !get_isPodcast.value ? 'Wdgt-Content-Ttl__txt--no-column' : '')
//Размер аватарки поста
const avatarSize = computed(() => {
  return get_type.value === 'alpha' ? 48 : 32;
});
//Закругление аватарки поста
const avatarRadius = computed(() => {
  return get_type.value === 'alpha' ? '6px' : '50%';
});
//Изменение стиля аватарки поста Альфы
const wrapperAlphaStyle = computed(() => {
  return get_type.value === 'alpha'
    ? {
        gridTemplateColumns: '48px 1fr',
        alignItems: 'center'
      }
    : {};
});
</script>

<style lang="scss">
@import './styles/Wdgt-Content-Ttl';
</style>
